var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-checkbox"},[_c('input',{attrs:{"type":"checkbox","id":_vm.id},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.handleChange}}),_c('label',{attrs:{"for":_vm.id}},[_c('span',{staticClass:"checkbox-icon"}),_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }